import { Injectable } from "@angular/core";
import { SharedService } from "../shared.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  url;
  constructor(
    private sharedService: SharedService,
    private httpClient: HttpClient,
  ) {
    this.url = sharedService.baseURL;
  }
  getGeoChart(data: any) {
    return this.httpClient.post<any>(`${this.url}/api/Home/GetGeoChart`, data);
  }
  getLineChart(data: any) {
    return this.httpClient.post<any>(`${this.url}/api/Home/GetLineChart`, data);
  }
  changePassword(data: any) {
    return this.httpClient.post<any>(`${this.url}/api/changePassword`, data);
  }
  getDashboardCount(compId: number) {
    return this.httpClient.get<any>(
      `${this.url}/api/Home/GetDashboardCount?compId=${compId}`,
    );
  }
  getHitUpdateCount(compId: number) {
    return this.httpClient.get<any>(
      `${this.url}/api/Home/GetHitUpdateCount?compId=${compId}`,
    );
  }
  getHitViewCount(compId: number) {
    return this.httpClient.get<any>(
      `${this.url}/api/Home/GetHitViewCount?compId=${compId}`,
    );
  }
  getScanIntelligenceInsights(data: any) {
    console.log("fetchScanIntelligenceInsights called");
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetScanIntelligenceInsights`,
      data,
    );
  }
  getNewDashboardData(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetNewDashboardData`,
      payload,
    );
  }

  getLiveFeed(payload: any) {
    // const params = new HttpParams().set("compId", compId.toString());

    return this.httpClient.post(`${this.url}/api/Home/GetLiveFeed`, payload);
  }

  getMapData(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetMapData`,
      payload,
    );
  }
  getScanIntelligenceGraph(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetScanIntelligenceGraph`,
      payload,
    );
  }
  /** Configuration page's saved settings (details.emailReport,
   *  details.scanRanges). */
  getConfigurationSettings(payload: { compId: number; userId: number }) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetConfigurationSettings`,
      payload,
    );
  }
  /** Configuration > India Map Settings: Save Changes. */
  saveScanRangeConfig(payload: {
    compId: number;
    userId: number;
    ranges: { rangeOrder: number; fromScan: number; toScan: number }[];
  }) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/SaveScanRangeConfig`,
      payload,
    );
  }
  /** Configuration > Automated Scan Reports: Save Changes. */
  saveEmailReportConfig(payload: {
    compId: number;
    userId: number;
    isEnabled: boolean;
    frequency: string;
    includeBrandInsights: boolean;
    includeAIAlerts: boolean;
    recipientType: "MyEmail" | "SelectedUsers";
    recipientUserIds: number[];
  }) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/SaveEmailReportConfig`,
      payload,
    );
  }
  /** Configuration > Automated Scan Reports "Add Users" picker. */
  getUserDropdownForConfig(payload: { userId: number; search: string }) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetUserDropdownForConfig`,
      payload,
    );
  }
  getRecentAlerts(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetRecentAlerts`,
      payload,
    );
  }
  getScanIntelligenceDrilldown(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetScanIntelligenceDrilldown`,
      payload,
    );
  }

  getScanMapReport(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/GetScanMapReport`,
      payload,
    );
  }
  getInventoryDashboardReport(payload: any) {
    return this.httpClient.post<any>(
      `${this.url}/api/Home/InventoryDashboardReport`,
      payload,
    );
  }
}
